import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import th from './locales/th.json'
import zh from './locales/zh.json'
import ru from './locales/ru.json'

const i18n = createI18n({
  locale: 'th', // หรือ 'en'
  messages: { en, th, zh, ru }
})
createApp(App).use(store).use(router).use(i18n).mount('#app')